import { render } from "./CreateStockOutView.vue?vue&type=template&id=81183d80&scoped=true"
import script from "./CreateStockOutView.vue?vue&type=script&lang=js"
export * from "./CreateStockOutView.vue?vue&type=script&lang=js"

import "./CreateStockOutView.vue?vue&type=style&index=0&id=81183d80&scoped=true&lang=css"

import exportComponent from "/Users/kokleng/Documents/Dollar/core_system/from_gitlab/pos-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81183d80"]])

export default __exports__